// Category tabs — simple show/hide over server-rendered panels, no fetch.
(function () {
  function init() {
    document.querySelectorAll('[data-category-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cat-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cat-panel]'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.dataset.i;
          tabs.forEach(function (t) { t.classList.toggle('active', t.dataset.i === i); });
          panels.forEach(function (p) { p.hidden = p.dataset.i !== i; });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
